module.exports = __webpack_public_path__ + "static/media/gold-badge.f83d7aec.svg";